<template>
    <component
        :is="layout"
        v-bind="layoutData"
        class="landing-page-entry"
    >
        <router-view :layout.sync="layout"/>
    </component>
</template>

<script>

export default {
    name: 'App',

    data: function () {
        return {
            appLayout: 'div',
        };
    },
    computed: {
        layout: {
            get() {
                for (const route of this.$route.matched) {
                    if (route.meta.layout) {
                        return route.meta.layout;
                    }
                }
                return this.appLayout;
            },
            set(val) {
                this.appLayout = val;
            },
        },
        layoutData() {
            return this.$root.layoutData;
        }
    },
    methods: {
        listenWindowResize() {
            if (this.windowResizeStarted) {
                return;
            }
            this.windowResizeStarted = true;
            const component = this;
            window.addEventListener('resize', debounce(function (e) {
                // Save the sizes.
                component.$window.updateWindowSizes();
                component.$bus.$emit('window:resize', component.$window.width, component.$window.height);
            }, 500));
        },
    },
};
</script>
<style>
.landing-page-entry {
    transition: all 0.3s ease;
}
</style>
